var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4722_13119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.046 3.0477C17.904 1.2357 15.096 0.0957031 12 0.0957031C8.904 0.0957031 6.096 1.2357 3.954 3.0477C1.524 5.2377 0 8.4297 0 11.9517C0 16.3317 2.286 20.0937 5.76 22.2357C7.572 23.2857 9.714 23.9037 12 23.9037C14.286 23.9037 16.428 23.2857 18.24 22.2357C21.714 20.1417 24 16.3317 24 11.9997C24 8.4297 22.476 5.2377 20.046 3.0477ZM10.05 18.2397L4.194 12.4317L5.526 11.0997L10.05 15.5277L18.618 7.1397L19.95 8.4717L10.05 18.2397Z",
    fill: "#FBA03D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4722_13119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckOrange);
export default __webpack_public_path__ + "static/media/IconCheckOrange.0f4d885f6d3b56c1113d9639dc89449f.svg";
export { ForwardRef as ReactComponent };